import React from 'react';
import { FormInput } from 'react-form';
import Select from 'react-select';
import { injectIntl } from "react-intl";

const SelectComp = ( { field, suffixIcon, ...rest, intl } ) => {
  return (
    field ?
      <FormInput field={field}>
        {( { setValue, getValue, setTouched } ) => {
          return (
            suffixIcon ?
              <div className="input-group">
                <Select
                  placeholder={rest.placeholder ? rest.placeholder : intl.formatMessage( { id: 'placeHolderSelect' })}
                  noResultsText={ intl.formatMessage( { id: 'noDataFound' } ) }
  
                  simpleValue={true}
                  searchable={true}
                  labelKey="name"
                  valueKey="id"
                  {...rest}
                  value={getValue()}
                  onChange={val => {
                    if( val !== getValue() ) {
                      setValue( val );
                      if( rest.onChange ) rest.onChange( val )
                    }
                  }}
                  onBlur={() => setTouched()}
                />
                {!!suffixIcon && <span className="input-group-addon pointer">{suffixIcon}</span>}
              </div> :
              <Select
                placeholder={rest.placeholder ? rest.placeholder : intl.formatMessage( { id: 'placeHolderSelect' } )}
                noResultsText={ intl.formatMessage( { id: 'noDataFound' } ) }
                simpleValue={true}
                searchable={true}
                labelKey="name"
                valueKey="id"
                {...rest}
                value={getValue()}
                onChange={val => {
                  if( val !== getValue() ) {
                    setValue( val );
                    if( rest.onChange ) rest.onChange( val )
                  }
                }}
                onBlur={() => setTouched()}
              />
          )
        }}
      </FormInput>
      :
      <Select
        placeholder={rest.placeholder ? rest.placeholder : intl.formatMessage( { id: 'placeHolderSelect' })}
        noResultsText={ intl.formatMessage( { id: 'noDataFound' } ) }
        simpleValue={true}
        searchable={true}
        labelKey="name"
        valueKey="id"
        {...rest}
        onChange={val => {
          if( rest.onChange ) rest.onChange( val )
        }}
      />
  )
}
module.exports = injectIntl( SelectComp );



// WEBPACK FOOTER //
// ./components/FormElements/Select/index.js